import styled from 'styled-components'

export const Full = styled.div`
    min-width:320px;
    max-width: 400px;
    margin: 200px auto;
    box-shadow: 0 5px 5px 5px #ccc;
    padding: 20px 0;
    border-radius: 10px;
    margin-top: 100px;
    min-height: 400px;
    display: flex;
    align-items: center
`;
export const Form = styled.form`
    width: 100%;
    & > h1{
        text-align: center;
        color: #888;
    }
    
    & > button{
        margin-top: 40px;
        border: 0;
        outline: none;
        position: relative;
        display: block;
        margin: 0 auto;
        width: 150px;
        padding: 1.2em 2em;
        text-decoration: none;
        text-align: center;
        cursor: pointer;
        user-select: none;
        color: white;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: linear-gradient(135deg, #6e8efb, #a777e3);
            border-radius: 4px;
            transition: box-shadow .5s ease, transform .2s ease; 
            will-change: transform;
            box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
            transform:
                translateY(var(--ty, 0))
                rotateX(var(--rx, 0))
                rotateY(var(--ry, 0))
                translateZ(var(--tz, -12px));
        }
        
        &:hover::before {
            box-shadow: 0 5px 15px rgba(0, 0, 0, .3);
        }
        
        &::after {
            position: relative;
            display: inline-block;
            content: attr(data-title);
            transition: transform .2s ease; 
            font-weight: bold;
            letter-spacing: .01em;
            will-change: transform;
            transform:
                translateY(var(--ty, 0))
                rotateX(var(--rx, 0))
                rotateY(var(--ry, 0));
        }
    }
`;
export const Row = styled.div`
    text-align: center;
    margin: 15px 0;
    & > input{
        width: 80%;
        height: 30px;
        text-indent: 25px;        
    }
`;